import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { withRateLimitRetry } from '@/lib/rateLimitRetry';
import { mergeLayout, APP_DEFAULT_SECTIONS } from '@/lib/homeLayout';

// variant: 'website' (custom domains) or 'app' (native app / Base44 domain)
export async function fetchHomeLayoutRecord(variant) {
  const query = variant === 'app' ? { variant: 'app' } : { variant: { $ne: 'app' } };
  const res = await withRateLimitRetry(() => base44.entities.HomePageLayout.filter(query, '-updated_date', 1));
  const rows = Array.isArray(res) ? res : res?.items || [];
  return rows[0] || null;
}

export default function useHomeLayout(variant = 'website') {
  const { data } = useQuery({
    queryKey: ['homeLayout', variant],
    queryFn: () => fetchHomeLayoutRecord(variant),
  });
  return mergeLayout(data, variant === 'app' ? APP_DEFAULT_SECTIONS : undefined);
}